import { render, staticRenderFns } from "./Manage-House-Type.vue?vue&type=template&id=fc8cdbee"
import script from "./Manage-House-Type.vue?vue&type=script&lang=js"
export * from "./Manage-House-Type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports